import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {AuthStats} from "../../dto/Ccedi/ccedi-models";
import {DatePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class CcediService {

  readonly apiPath = 'ccedi/';

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
  ) {

  }

  getAuthStats(from: Date, to: Date, interval: string, product: number|null, company: number|null): Observable<AuthStats> {

    let httpParams = new HttpParams();

    httpParams = httpParams.append('from', this.datePipe.transform(from, 'yyyy-MM-dd'));
    httpParams = httpParams.append('to', this.datePipe.transform(to, 'yyyy-MM-dd'));
    httpParams = httpParams.append('interval', interval);
    if ( product)
      httpParams = httpParams.append('product', product.toString());
    if ( company)
      httpParams = httpParams.append('company', company.toString());

    return this.http.get( this.apiPath, {params: httpParams } ) as Observable<AuthStats>;
  }




}
